import React from "react";
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import HomeDecor from './HomeDecorComponent';
import CarpetComponent from './CarpetComponent';
import ScrollUpButton from "react-scroll-up-button";

function HomeDecorBlock() {
  return <HomeDecor />;
}

function RugsBlock() {
  return <CarpetComponent />;
}
function NavigationBlock() {
  return (
    <div>
    <Router>
      <div>
        <nav>
          <ul>
          <li>
              <NavLink className="comp-link" exact activeClassName='selected' to="/">Rugs</NavLink>
            </li>
            <li>
              <NavLink className="comp-link" activeClassName='selected' to="/home-decore/">Home Decor</NavLink>
            </li>
          </ul>
        </nav>
        <Route path="/home-decore/" component={HomeDecorBlock} />
        <Route path="/" exact component={RugsBlock} />
      </div>
    </Router> 
    <ScrollUpButton /> 
    </div>
  );
}

export default NavigationBlock;